import React from "react";

/** Injects meta + JSON-LD schema tags into <head> for each route. */
export default function Seo({
  title = "Vlyt · Certainty in Motion",
  description = "Vlyt is the intra-community mobility platform for Covenant University. Zero-leakage matching, no-SIM authentication, and a Royal Daily Pass that guarantees your morning movement.",
  canonical = "https://govlyt.com/",
  image = "https://customer-assets.emergentagent.com/job_vlyt-launch/artifacts/3733o5po_02ebb175-0a71-49d5-93b5-137f92b27689.jpeg",
  jsonLd = null,
}) {
  React.useEffect(() => {
    document.title = title;

    const setMeta = (attr, name, content) => {
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("name", "theme-color", "#0E0E12");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    setMeta("name", "apple-mobile-web-app-title", "Vlyt");
    setMeta("name", "application-name", "Vlyt");

    // canonical
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    // JSON-LD
    const scriptId = "vlyt-jsonld";
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      document.head.appendChild(script);
    }
    const graph = jsonLd || defaultGraph();
    script.textContent = JSON.stringify(graph);
  }, [title, description, canonical, image, jsonLd]);

  return null;
}

function defaultGraph() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "Vlyt Technologies",
        url: "https://govlyt.com",
        logo: "https://govlyt.com/logo.png",
        sameAs: [
          "https://linkedin.com/company/vlyt-technologies",
        ],
        founder: { "@id": "https://govlyt.com/#founder" },
      },
      {
        "@type": "Person",
        "@id": "https://govlyt.com/#founder",
        name: "Miesindou Alagha",
        jobTitle: "Founder & Strategic Architect",
        worksFor: { "@type": "Organization", name: "Vlyt Technologies" },
        sameAs: [
          "https://scholar.google.com/scholar?cluster=852375541475616738",
          "https://www.researchgate.net/institution/Covenant-University/members/81",
          "https://www.instagram.com/p/DE7LbA8sXug/",
          "https://rocketreach.co/covenant-university-student-council-profile_b6a54b2ac87fe612",
          "https://ng.linkedin.com/in/mikeal-alagha",
        ],
      },
      {
        "@type": "SoftwareApplication",
        name: "Vlyt",
        operatingSystem: "iOS, Android, PWA",
        applicationCategory: "TransportationApplication",
        offers: {
          "@type": "Offer",
          price: "10",
          priceCurrency: "NGN",
          description: "Flat Platform Access Fee per ride.",
        },
      },
      {
        "@type": "Service",
        serviceType: "Intra-community mobility",
        provider: { "@type": "Organization", name: "Vlyt Technologies" },
        areaServed: { "@type": "Place", name: "Covenant University, Ota, Nigeria" },
      },
    ],
  };
}
